import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tooltip
} from '@material-ui/core';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
const SECONDARY_CREATION_COLUMNS = [
    {
        id: 'totalUploadDays',
        label: 'Total Upload Days',
        tooltip: 'Must Above 0, Range From 1 To 9999.',
        placeholder: 'Total Upload Days'
    },
    {
        id: 'validUploadCount',
        label: 'Valid Upload Count',
        tooltip: 'Must Above 0, Range From 1 To 9999.',
        placeholder: 'Valid Upload Count'
    },
    {
        id: 'totalViews',
        label: 'Total Views',
        tooltip: 'Must Above 0, Range From 1 To 99999999.',
        placeholder: 'Total Views'
    },
    {
        id: 'maxRevenue',
        label: 'Max Revenue($)',
        tooltip: 'Must Above 0, Range From 1 To 99999999.',
        placeholder: 'Max Revenue'
    },
    {
        id: 'prizePool',
        label: 'Prize Pool($)',
        tooltip: 'Must Above 0, Range From 1 To 99999999.',
        placeholder: 'Prize Pool'
    }
];

const TableHeaderCell = React.memo(({ label, tooltip }) => (
    <TableCell align="center">
        {label} &nbsp;
        <Tooltip title={tooltip} placement="top">
            <i className="fa fa-info-circle" />
        </Tooltip>
    </TableCell>
));

const TableField = React.memo(({ item, fieldConfig }) => (
    <TableCell>
        <Field
            name={`${item}.${fieldConfig.id}`}
            id={`${item}.${fieldConfig.id}`}
            type="text"
            component={CustomInput}
            placeholder={fieldConfig.placeholder}
            onlyNumbers="true"
        />
    </TableCell>
));

const SecondaryCreationSplitTable = ({ fields, questForm, questStarted, isNew }) => {
    const showActionColumn = (!questStarted || isNew) &&
        (questForm?.values?.rankTiers?.length > 0 || questForm?.values?.splitTiers?.length > 1);

    return (
        <>
            <TableHead>
                <TableRow>
                    {SECONDARY_CREATION_COLUMNS.map(column => (
                        <TableHeaderCell
                            key={column.id}
                            label={column.label}
                            tooltip={column.tooltip}
                        />
                    ))}
                    {showActionColumn && (
                        <TableHeaderCell
                            label="Action"
                            tooltip="You can delete this tier."
                        />
                    )}
                </TableRow>
            </TableHead>
            <TableBody>
                {fields.map((item, index) => (
                    <TableRow key={index}>
                        {SECONDARY_CREATION_COLUMNS.map(column => (
                            <TableField
                                key={`${item}.${column.id}`}
                                item={item}
                                fieldConfig={column}
                            />
                        ))}
                        {showActionColumn && (
                            <TableCell align="center">
                                <div className="RepeaterWrapper__item__new">
                                    <button
                                        className="RepeaterWrapper__item-remove-new"
                                        type="button"
                                        onClick={() => fields.remove(index)}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </TableCell>
                        )}
                    </TableRow>
                ))}
            </TableBody>
        </>
    );
};

SecondaryCreationSplitTable.propTypes = {
    fields: PropTypes.object.isRequired,
    questForm: PropTypes.object,
    questStarted: PropTypes.bool,
    isNew: PropTypes.bool
};

export default React.memo(SecondaryCreationSplitTable);